<div class="d-flex align-items-center">
<ul ngbNav #nav="ngbNav" class="nav-tabs flex-grow-1" [destroyOnHide]="false" (navChange)="onNavChange($event)" [activeId]="activeId">
	@if (istPunktartMitProtokoll(bp.type)) {
		<li ngbNavItem="Allgemein">
			<a ngbNavLink>Allgemein</a>
			<ng-template ngbNavContent>
				<bp-bohrpunkt-allgemein [bp]="bp"></bp-bohrpunkt-allgemein>
			</ng-template>
		</li>
		<li ngbNavItem="Boden">
			<a ngbNavLink>Boden</a>
			<ng-template ngbNavContent>
				<bp-bohrpunkt-boden [bp]="bp"></bp-bohrpunkt-boden>
			</ng-template>
		</li>
		<li ngbNavItem="Vegetation">
			<a ngbNavLink>Vegetation</a>
			<ng-template ngbNavContent>
				<bp-bohrpunkt-vegetation [bp]="bp"></bp-bohrpunkt-vegetation>
			</ng-template>
		</li>
	}
	@else if (istPunktartMitKurzprotokoll(bp.type)) {
		<li ngbNavItem="Kurzprotokoll">
			<a ngbNavLink>Kurzprotokoll</a>
			<ng-template ngbNavContent>
				<bp-bohrpunkt-kurzprotokoll [bp]="bp"></bp-bohrpunkt-kurzprotokoll>
			</ng-template>
		</li>
	}
	<li ngbNavItem="Karte" (shown)="onDisplayMap()">
		<a ngbNavLink>Karte</a>
		<ng-template ngbNavContent>
			<bp-bohrpunkt-map *ngIf="displayMap" [bp]="bp" [bps]="bps" [pointsFilter]="pointsFilter" [mapStatus]="mapStatus" (pointDeleted)="onPointDeleted()"></bp-bohrpunkt-map>
		</ng-template>
	</li>
	<li ngbNavItem="Hinweise">
		<a ngbNavLink>Hinweise</a>
		<ng-template ngbNavContent>
			<bp-bohrpunkt-plausi [bp]="bp"></bp-bohrpunkt-plausi>
		</ng-template>
	</li>
</ul>
<!-- Protokoll-Info -->
<span class="protocol-info ms-auto me-3">
	<img [src]="'assets/img/points/' + bp.type + '.svg'" alt="" class="protocol-type-icon">
	<span class="protocol-nummer">{{ bp.header ? bp.header.nummer : '–' }}</span>
	<span class="protocol-separator">|</span>
	<span class="protocol-detail">{{ (bp.header && bp.header.aufnahme ? bp.header.aufnahme.kartierer : '–') | maskForGuest }}</span>
	<span class="protocol-separator">|</span>
	<span class="protocol-detail">{{ (bp.header && bp.header.aufnahme ? dateString(bp.header.aufnahme.datum) : '–') | maskForGuest }}</span>
</span>
</div>
<div [ngbNavOutlet]="nav"></div>
